import React, { useState, useEffect, useContext, useRef } from 'react';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form';
import CloseButton from 'react-bootstrap/CloseButton';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import * as dayjs from 'dayjs'
import CalendarModal from '../Modals/CalendarModal';
import { getContentWithAction, postContentWithAction, putContentWithAction, getContentWithActionAndLanguage } from '../../apiConnect';
import { getSelectedPlot, customStyles, formatGroupLabel, getSelectedFarmId, getSelectedYear } from '../../common';
import { useAlert } from 'react-alert'
import AppContext from '../../AppContext';
import { dayJsFormatDate, valueMaxObservation, preparePhotos, formatBytes, getFileSize } from '../../commonFunctions';
import { ObservationCategory } from '../../Constants/SharedMapFeature';
import ImageShowModal from '../Modals/ImageShowModal';
import NumberFormat from 'react-number-format';
import { FaMapMarkerAlt, FaTrash, FaRegEye } from "react-icons/fa";
import { BsArrowReturnLeft } from "react-icons/bs";
import { IoSaveSharp } from "react-icons/io5";
import { TbPlant, TbCategory } from "react-icons/tb";
import { IoMdCalendar } from "react-icons/io";
import { FiUpload } from "react-icons/fi";
import Carousel from 'react-bootstrap/Carousel';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ConfirmModal from '../Alerts/ConfirmModal';

import '../../css/general.css'
import '../../css/mobiNewStyles.css'

const ObservationSharingModal = (props) => {
    const { t } = useTranslation();
    const { auth } = useContext(AppContext);

    const [calendarShow, setCalendarShow] = useState(false);
    const [date, setDate] = useState(dayjs().format());
    const [description, setDescription] = useState('');

    //PHOTOS    
    const [files, setFiles] = useState([]);
    const [newImages, setNewImages] = useState([]);
    const [carouselIndex, setCarouselIndex] = useState(0);

    const fileRef = useRef();
    const [imageShow, setImageShow] = useState(false);
    const [imageToView, setImageToView] = useState(false);
    const [buttonWriteShow, setButtonWriteShow] = useState(true);
    const [observationsList, setObservationsList] = useState([]);
    const [observationOptions, setObservationOptions] = useState([]);
    const [observationMeasures, setObservationMeasures] = useState([]);

    const [coordinates, setCoordinates] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedObservation, setSelectedObservation] = useState(null);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [amount, setAmount] = useState(0);
    const [shareChecked, setShareChecked] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [confirmDeleteShow, setConfirmDeleteShow] = useState(false);

    const observationCategories = [
        { value: ObservationCategory.Weeds, label: t('Weeds') },
        { value: ObservationCategory.Diseases, label: t('Diseases') },
        { value: ObservationCategory.Pests, label: t('Pests') },
        { value: ObservationCategory.Other, label: t('Other') }
    ];

    const selectedPlot = getSelectedPlot();
    const alert = useAlert();

    const imageStyle = {
        width: '125px',
        height: '100px',
        cursor: 'pointer'
    };

    const OBSERVATION_AMOUNT_DISABLED = [7, 14, 15, 16, 17];

    const MAX_IMAGES_SIZE = 23 * 1024 * 1024; // 23 MB per save (single API call)

    // Only the images that will actually be sent in the next API call count
    // toward the per-upload size limit. 
    const totalNewImagesSize = newImages.reduce((acc, f) => acc + getFileSize(f), 0);

    const OBSERVATION_AMOUNT_LITTLE = {
        value: 15,
        mode: 15,
        label: t('AmountLittle')
    };

    const OBSERVATION_AMOUNT_MODERATE = {
        value: 16,
        mode: 16,
        label: t('AmountModerate')
    };

    const OBSERVATION_AMOUNT_ALOT = {
        value: 17,
        mode: 17,
        label: t('AmountAlot')
    };

    const handleObservationUnitSorting = (observationUnits) => {
        const sortedList = [...observationUnits];
        sortedList.unshift(OBSERVATION_AMOUNT_LITTLE, OBSERVATION_AMOUNT_MODERATE, OBSERVATION_AMOUNT_ALOT);
        sortedList.some((item, idx) =>
            item.value === 14 &&
            sortedList.unshift(
                sortedList.splice(idx, 1)[0]
            )
        );
        sortedList.some((item, idx) =>
            // Remove "asteikko"
            item.value === 7 &&
            sortedList.splice(idx, 1)[0]
        );
        return sortedList;
    };

    useEffect(() => {
        if (!props.show || !props.eventdata) return;

        // fetch data
        Promise.all([
            getContentWithAction(auth.getAccessToken(), 'resource', 'observe', {}),
            getContentWithActionAndLanguage(auth.getAccessToken(), 'resource', 'observationMeasure', {})
        ]).then(([observations, observationMeasures]) => {
            setObservationsList(observations);
            const completeList = [
                { label: t('All'), options: observations }
            ];

            // Set grouped observations list
            setObservationOptions(completeList);

            // Set observation measures with sorted units
            const sortedMeasures = observationMeasures ? handleObservationUnitSorting(observationMeasures) : [];
            setObservationMeasures(sortedMeasures);
            setIsLoading(false);

            // Handle edit - populate form with existing feature data
            if (!props.eventdata.isNew) {
                const feature = props.eventdata;

                getContentWithAction(auth.getAccessToken(), 'photo', 'sharedPhotos', { sharedFeatureId: feature.SharedFeatureId })
                    .then((data) => {
                        setFiles(preparePhotos(data));
                    });

                // Set category
                const categoryValue = feature.CategoryId ?? feature.categoryId;
                const cat = observationCategories.find(c => c.value === categoryValue);
                if (cat) {
                    setSelectedCategory(cat);
                    var filteredObs = observations.filter(o => o.value.startsWith(cat.value.toString()));
                    if (cat.value === ObservationCategory.Pests) {
                        let extraObservations = new Set(["6102", "6108", "6118", "6119", "6225", "6229", "6230", "6231"]);
                        let obsData = observations.filter(o => extraObservations.has(o.value));
                        obsData.forEach(o => filteredObs.push(o));
                    }
                    setObservationOptions([{ label: t('All'), options: filteredObs }]);
                }

                // Set observation type
                const objectMethod = feature.ObservationId ?? feature.observationId;
                const obs = observations.find(o => o.value === objectMethod);
                if (obs) setSelectedObservation(obs);

                // Set unit
                const unitValue = feature.Unit ?? feature.unit;
                const unit = sortedMeasures.find(m => String(m.value) === String(unitValue) || String(m.mode) === String(unitValue));
                if (unit) setSelectedUnit(unit);

                // Set amount
                const amountValue = feature.Amount ?? feature.amount;
                if (amountValue !== undefined) setAmount(amountValue);

                // Set description
                const extraInfo = feature.ExtraInfo ?? feature.extraInfo;
                if (extraInfo) setDescription(extraInfo);

                // Set date
                const sharedDate = feature.SharedDate ?? feature.sharedDate;
                if (sharedDate) setDate(sharedDate);

                // Set share checked
                const visibility = feature.Visibility ?? feature.visibility;
                if (visibility !== undefined) setShareChecked(visibility);
                setIsLoading(false);
            }
        }).catch((error) => {
            alert.show(t('ErrorWhileFetchingData'));
        });

        // Set modal data
        setCoordinates(props.eventdata.Coordinates ?? props.eventdata.coordinates);
    }, [props.eventdata, props.show]);

    const handleCategoryChange = (data) => {
        setSelectedObservation(null);
        setSelectedCategory(data);
        var obs = observationsList.map(o => ({...o}));
        var filteredObservations = obs.filter(o => o.value.startsWith(data.value.toString()));
        if (data.value === ObservationCategory.Pests) {
            // Add some extra options for pests
            let extraObservations = new Set(["6102", "6108", "6118", "6119", "6225", "6229", "6230", "6231"]);
            let obsData = observationsList.filter(o => extraObservations.has(o.value));
            obsData.forEach(o => filteredObservations.push(o));
        }
        setObservationOptions([{ label: t('all'), options: filteredObservations }]);
    }

    const validateObservation = () => {
        let valid = true;

        // Check required fields
        if (!selectedCategory || !selectedCategory.value) {
            alert.show(t('PleaseSelectCategory'), { type: 'error' });
            valid = false;
        }

        if (!selectedObservation || !selectedObservation.value) {
            alert.show(t('PleaseSelectObservation'), { type: 'error' });
            valid = false;
        }

        if (!selectedUnit || !selectedUnit.value) {
            alert.show(t('PleaseSelectUnit'), { type: 'error' });
            valid = false;
        }

        // Check amount if not a disabled unit type
        if (selectedUnit && !OBSERVATION_AMOUNT_DISABLED.find(m => m === selectedUnit.mode)) {
            if (!amount || amount === 0) {
                alert.show(t('PleaseEnterAmount'), { type: 'error' });
                valid = false;
            }
        }

        if (props.eventdata.isNew) {
            if (!coordinates || !coordinates.longitude || !coordinates.latitude) {
                alert.show(t('PleaseDefineLocation'), { type: 'error' });
                valid = false;
            }
        }

        return valid;
    }

    const handleSave = () => {
        setIsSaving(true);
        if (!validateObservation()) {
            setIsSaving(false);
            return;
        }

        let images = [];
        if (newImages.length) {
            newImages.forEach(newI => {
                let photo = newI.thumbnailImage ? newI.thumbnailImage.split(',')[1] : '';
                if (photo) {
                    images.push(photo);
                }
            });
        }

        // Prepare data model
        const observationData = {
            sharedFeatureId: props.eventdata.isNew ? null : props.eventdata.SharedFeatureId,
            farmId: getSelectedFarmId(),
            farmYear: getSelectedYear(),
            longitude: coordinates?.longitude,
            latitude: coordinates?.latitude,
            observationId: selectedObservation.value,
            categoryId: selectedCategory.value,
            amount: amount,
            featureType: '5301',
            unit: selectedUnit.mode.toString(),
            visibility: shareChecked,
            extraInfo: description || '',
            sharedDate: date,
            images: images
        };

        const action = props.eventdata.isNew ? 'addNewSharedFeature' : 'updateSharedFeature';

        if (props.eventdata.isNew) {
            // ADD NEW
            postContentWithAction(auth.getAccessToken(), 'map', action, observationData,
                (response) => {
                    setIsSaving(false);
                    alert.show(t('SavedSuccesfully'), { type: 'success' });
                    props.onHide();
                    // Refresh map if callback exists
                    props.onSaved();
                }).catch((error) => {
                    setIsSaving(false);
                    if (error?.response?.status === 413) {
                        alert.show(t('UploadTooLarge'), { type: 'error' });
                    }
                    else {
                        alert.show(t('ErrorWhileSaving'), { type: 'error' });
                    }
                });
        }
        else {
            // UPDATE
            var content = [];
            content.push(observationData);
            putContentWithAction(auth.getAccessToken(), 'map', action, {models: content}).then(
                (response) => {
                    setIsSaving(false);
                    alert.show(t('SavedSuccesfully'), { type: 'success' });
                    props.onHide();
                    // Refresh map if callback exists
                    props.onSaved();
                }).catch((error) => {
                    setIsSaving(false);
                    if (error?.response?.status === 413) {
                        alert.show(t('UploadTooLarge'), { type: 'error' });
                    }
                    else {
                        alert.show(t('ErrorWhileSaving'), { type: 'error' });
                    }
                });
        }

        // Call API
    }

    const handleDelete = () => {
        setIsDeleting(true);
        const deleteData = {
            farmId: getSelectedFarmId(),
            sharedFeatureId: props.eventdata.SharedFeatureId
        };

        postContentWithAction(auth.getAccessToken(), 'map', 'deleteSharedFeature', deleteData,
            (response) => {
                setIsDeleting(false);
                alert.show(t('DeletedSuccesfully'), { type: 'success' });
                props.onHide();
                props.onSaved();
            }).catch((error) => {
                setIsDeleting(false);
                alert.show(t('ErrorWhileDeleting'), { type: 'error' });
            });
    }

    const deletePhoto = (mediaId) => {
        postContentWithAction(auth.getAccessToken(), 'memo', 'deletePhoto', {
            mediaId: mediaId,
            // TODO ADD PLOTID : plotId: plotId 
        }, () => {
            props.setRefresh(Date.now());
            props.onHide();
        });
    }

    const imageHandler = (e) => {
        let allfiles = []
        // Only the new (unsaved) images contribute to the per-save 23 MB cap.
        let currentTotal = newImages.reduce((acc, f) => acc + getFileSize(f), 0);

        for (let i = 0; i < e.target.files.length; i++) {
            const fileItem = e.target.files[i];
            const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
            if (!acceptedImageTypes.includes(fileItem.type)) continue;

            if (currentTotal + fileItem.size > MAX_IMAGES_SIZE) {
                alert.show(t('UploadTooLarge'), { type: 'error' });
                continue;
            }
            currentTotal += fileItem.size;

            // Capture name/size in the closure so they're attached to the processed entry
            const capturedName = fileItem.name;
            const capturedSize = fileItem.size;

            var reader = new FileReader();
            reader.onload = function (f) {
                let d = {};
                d.thumbnailImage = f.target.result;
                d.name = capturedName;
                d.size = capturedSize;
                allfiles.push(d)

                if (files.length > 0) {
                    setFiles([...files, ...allfiles]);
                }
                else {
                    setFiles(allfiles);
                }

                if (newImages.length > 0) {
                    setNewImages([...newImages, ...allfiles]);
                }
                else {
                    setNewImages(allfiles);
                }
            }

            reader.readAsDataURL(fileItem);
        }
        // Reset the input so re-selecting the same file triggers onChange again
        if (e.target) e.target.value = '';
    }

    const handleImageRemoval = (file) => {
        var allImages = [...files];
        var index = allImages.findIndex((element) => element.name === file.name);
        if (index !== -1) {
            allImages.splice(index, 1);
            setFiles(allImages);
            // Move carousel to the next available slide so we don't end up on a deleted (empty) tab
            const nextIndex = allImages.length === 0
                ? 0
                : Math.min(index, allImages.length - 1);
            setCarouselIndex(nextIndex);
        }
        if (file.mediaId)
            deletePhoto(file.mediaId);
    }

    return (
        <>
            <Modal show={props.show} onHide={props.onHide} >
                <Modal.Header closeButton>
                    <Modal.Title className="text-dark">
                        {t('SharedObservation')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="new-modal-body">
                    {isLoading && <div className="text-center"><Spinner animation="border" role="status" variant="mmfi-new" /></div>}
                    {!isLoading &&
                        <Form>
                            <Form.Group controlId="plantSelect">
                                <Form.Label className="text-dark mobiwisu-new-label ">{t('Category')}</Form.Label>
                                <Select
                                    className={!selectedCategory?.value ? "text-dark new-invalid-border mobiwisu-new-control" : "text-dark mobiwisu-new-control"}
                                    value={selectedCategory?.label ? selectedCategory : { label: t('Select'), value: null }}
                                    onChange={(data) => { handleCategoryChange(data); }}
                                    options={observationCategories}
                                    styles={customStyles}
                                    formatGroupLabel={formatGroupLabel}
                                />
                                <TbCategory className="input-icon" color={'gray'} fontSize={28} />
                            </Form.Group>

                            <Form.Group controlId="plantSelect">
                                <Form.Label className="text-dark mobiwisu-new-label ">{t('Observation')}</Form.Label>
                                <Select
                                    className={!selectedObservation?.value ? "text-dark new-invalid-border mobiwisu-new-control" : "text-dark mobiwisu-new-control"}
                                    value={selectedObservation?.label ? selectedObservation : { label: t('Select'), value: null }}
                                    onChange={(data) => { setSelectedObservation(data); }}
                                    options={observationOptions}
                                    styles={customStyles}
                                    formatGroupLabel={formatGroupLabel}
                                />
                                <FaRegEye className="input-icon" color={'gray'} fontSize={28} />
                            </Form.Group>

                            <Row>
                                <Col>
                                    <Form.Group controlId="formFieldOperation">
                                        <Form.Label className="mobiwisu-new-label text-dark">{t('UnitAmount')}</Form.Label>
                                        <NumberFormat
                                            className="form-control mobiwisu-new-control"
                                            disabled={selectedUnit && OBSERVATION_AMOUNT_DISABLED.find(m => m === selectedUnit.mode)}
                                            onValueChange={value => {
                                                if (value.floatValue || value.floatValue === 0) {
                                                    setAmount(value.floatValue);
                                                }
                                            }}
                                            value={selectedUnit && OBSERVATION_AMOUNT_DISABLED.find(m => m === selectedUnit.mode) ? '' : amount ? amount : ''}
                                            decimalScale={2}
                                            fixedDecimalScale={false}
                                            displayType={'input'}
                                            thousandSeparator={' '}
                                            isAllowed={valueMaxObservation}
                                            allowNegative={false}
                                            allowedDecimalSeparators={['.', ',']}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="formFieldUnit">
                                        <Form.Label className="mobiwisu-new-label text-dark">{t('Unit')}</Form.Label>
                                        <Select
                                            className="text-dark mobiwisu-new-control"
                                            value={selectedUnit ? selectedUnit : null}
                                            onChange={(data) => {
                                                setSelectedUnit(data);
                                                // Clear amount if disabled unit is selected
                                                if (OBSERVATION_AMOUNT_DISABLED.find(m => m === data.mode)) {
                                                    setAmount(0);
                                                }
                                            }}
                                            options={observationMeasures}
                                            placeholder={t('Unit')}
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>


                            <Form.Group controlId="formMemoText">
                                <Form.Label className="mobiwisu-new-label text-dark">{t('NoteDescription')}</Form.Label>
                                <Form.Control type="text" onChange={(event) => { setDescription(event.target.value) }}
                                    className="mobiwisu-new-control mobi-text-area"
                                    as="textarea"
                                    value={description}
                                    placeholder={t('Note')}
                                    maxLength={150} />
                                <div className="char-counter-new">{description.length}/150</div>
                            </Form.Group>
                            <Form.Group controlId="formDate">
                                <Form.Label className="mobiwisu-new-label text-dark">{t('Date')}</Form.Label>
                                <div>
                                    <Form.Control className="mobiwisu-new-control" type="text" onClick={() => setCalendarShow(true)} placeholder={t('Date')} value={dayJsFormatDate(date)} onChange={() => { }} />
                                    <IoMdCalendar className="input-icon-short" color={'gray'} fontSize={30} />
                                </div>
                            </Form.Group>
                            {coordinates && coordinates.longitude !== 0 && coordinates.latitude !== 0 ?
                                <div>
                                    <Form.Label className="text-dark new-coordinates-label">
                                        <FaMapMarkerAlt fontSize={30} /> {t('LocationDefined')} ({coordinates.wgs.longitude},   {coordinates.wgs.latitude}) 
                                    </Form.Label>
                                </div>
                                : // If no coordinates then show button
                                ''}
                            <Form.Group>
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    id="show-shared-switch"
                                    label={t('ShareFeature')}
                                    className="mobi-new-custom-switch"
                                    checked={shareChecked}
                                    onChange={(event) => { setShareChecked(!shareChecked) }}
                                />
                            </Form.Group>

                            < br />

                            {buttonWriteShow ?
                                <Form.Group>
                                    <Button variant="new-outline-success" onClick={() => fileRef.current.click()}><FiUpload className="button-icon" /> {t('LoadPhotos')}</Button>
                                    <input
                                        ref={fileRef}
                                        accept="image/*"
                                        type="file"
                                        onChange={imageHandler}
                                        multiple
                                        hidden
                                    />
                                    {newImages.length > 0 &&
                                        <div className="file-size-counter">
                                            {t('TotalImageSize')}: {formatBytes(totalNewImagesSize)} / {formatBytes(MAX_IMAGES_SIZE)}
                                        </div>
                                    }
                                </Form.Group>
                                : ''}

                            {files.length > 0 &&
                                <Carousel variant="dark" interval={null} indicators={false} activeIndex={carouselIndex} onSelect={(selectedIndex) => setCarouselIndex(selectedIndex)}>
                                    {files.map((file, key) => {
                                        return (
                                            <Carousel.Item className="image-carousel" key={key}>
                                                <Carousel.Caption>
                                                    <div key={key}>
                                                        <br />
                                                        <img src={file.thumbnailImage ? `${file.thumbnailImage}` : URL.createObjectURL(file)} alt={file.name} style={imageStyle} onClick={() => {
                                                            setImageToView(file);
                                                            setImageShow(true);
                                                        }} />

                                                        {buttonWriteShow ?
                                                            <Button variant="new-outline-success" className="image-remove" onClick={() => handleImageRemoval(file)}><FaTrash className="button-icon" /> {t('DeletePhoto')} </Button>
                                                            : ''}
                                                    </div>
                                                </Carousel.Caption>
                                            </Carousel.Item>
                                        )
                                    })}
                                </Carousel>
                            }
                        </Form>
                    }
                </Modal.Body>
                <Modal.Footer className="modal-footer-right-align">
                    {!props.eventdata?.isNew && buttonWriteShow &&
                        <Button variant="new-outline-secondary" className="footer-button-left" onClick={() => setConfirmDeleteShow(true)} disabled={isDeleting}>
                            {isDeleting ? <Spinner as="span" animation="border" size="sm" role="status" variant="secondary" /> : <><FaTrash className="button-icon" /> {t('Delete')}</>}
                        </Button>
                    }
                    <Button variant="new-outline-secondary" onClick={() => { props.onHide(); }}><><BsArrowReturnLeft /> {t('Cancel')}</></Button>

                    {buttonWriteShow === true ?
                        <Button variant="success" className="btn-show-more btn-new-save" onClick={handleSave} disabled={isSaving}>{isSaving ? <Spinner as="span" animation="border" size="sm" role="status" variant="secondary" /> : <><IoSaveSharp className="button-icon" /> {t('Save')}</>}</Button>
                        : ''}
                </Modal.Footer>
            </Modal>
            <ConfirmModal
                show={confirmDeleteShow}
                onHide={() => setConfirmDeleteShow(false)}
                title={t('DeleteSharedFeature')}
                accept={() => {
                    setConfirmDeleteShow(false);
                    handleDelete();
                }}
                decline={() => setConfirmDeleteShow(false)}
            />
            <CalendarModal
                show={calendarShow}
                onHide={() => setCalendarShow(false)}
                onChange={(value) => {
                    setDate(value);
                }}
                selecteddate={date}
            />
            <ImageShowModal
                show={imageShow}
                onHideImage={() => {
                    setImageShow(false);
                }}
                image={imageToView}
            />
        </>
    );
}

export default ObservationSharingModal;